import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        ActivTrack LLC © Copyright 2023 | All rights reserved. <br></br>
        {/* // eslint-disable-next-line */ }
        <a href="https://activtrackrtm.com/terms.html" target="_blank" rel="noopener noreferrer">
          Terms of Use & Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default Footer;
